import React from "react"
import { Outlet } from "react-router-dom"
import { styled, Box } from "@mui/material"

import Div100vh from "react-div-100vh"
const OutletWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "100%",
}))

export const BaseAppLayout = () => {
  return (
    <Div100vh data-name="AppLayout">
      <OutletWrapper>
        <Outlet />
      </OutletWrapper>
    </Div100vh>
  )
}
